import styled from 'styled-components'
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 12px;
  margin-top: 16px;
`

export const MenuItemContainer = styled.div`
  margin-top: 8px;
  gap: 16px;
  display: flex;
  flex-direction: column;
`

export const AlertBoxContainer = styled.div`
  width: 100%;
  display: flex;
  position: absolute;
  bottom: 0;
  padding: 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
`
